<template>
  <svg
    width="17"
    height="14"
    viewBox="0 0 17 14"
  >
    <path d="M8.74317 13.8028L14.9874 7.49941C16.6718 5.78856 16.6665 3.02549 14.9706 1.31249C13.3077 -0.367079 10.6427 -0.410504 8.94448 1.19086C8.90787 1.22539 8.8717 1.26068 8.836 1.29673L8.23963 1.90026L7.63508 1.28963C7.60194 1.25616 7.5684 1.22333 7.53447 1.19116C5.8326 -0.422744 3.16318 -0.398067 1.50786 1.2739C-0.180458 2.9792 -0.172218 5.75004 1.52343 7.46275L7.80032 13.8028C8.06068 14.0657 8.48281 14.0657 8.74317 13.8028ZM9.54664 2.00029C10.8431 0.691352 12.9491 0.692036 14.2599 2.01604C15.5719 3.34123 15.5738 5.47734 14.2759 6.79681L14.2748 6.79783L8.27182 12.8577L2.23407 6.75919C0.920724 5.43263 0.919501 3.28953 2.2185 1.97746C3.51189 0.671064 5.61649 0.672083 6.92444 1.99319L7.88465 2.96306C8.08044 3.16082 8.40003 3.16067 8.59563 2.96272L9.54664 2.00029Z" />
  </svg>
</template>
